import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const handleLinkClick = (path) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  // Detect current theme from body class
  const isElysianGold = document.querySelector('.theme-elysian-gold') !== null;
  const isElysianDark = document.querySelector('.theme-elysian-dark') !== null;

  // Elysian Gold/Dark Footer
  if (isElysianGold || isElysianDark) {
    return (
      <footer className="footer">
        <div className="footer-divider"></div>
        <div className="footer-links">
          <a className="footer-link" onClick={() => handleLinkClick('/features')}>Features</a>
          <a className="footer-link" onClick={() => handleLinkClick('/events')}>Events</a>
          <a className="footer-link" onClick={() => handleLinkClick('/magazine')}>Magazine</a>
          <a className="footer-link" onClick={() => handleLinkClick('/success-stories')}>Success Stories</a>
          <a className="footer-link" onClick={() => handleLinkClick('/contact')}>Contact</a>
        </div>
        <small className="footer-text">&copy; {new Date().getFullYear()} Success Club. All rights reserved.</small>
      </footer>
    );
  }

  // Default Footer (for other themes)
  return (
    <footer className="relative z-10 bg-gray-900 text-white py-12 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Success Club Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-14 h-14 flex items-center justify-center bg-white rounded-full shadow-lg overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_refined-login/artifacts/7hacqtlv_Success%20Club%20Logo%20Files%20-%203%20%281%29.png" 
                  alt="Success Club Logo" 
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    scale: '1.5'
                  }}
                />
              </div>
              <h3 className="text-xl font-bold">Success Club</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Elite business network for entrepreneurs and leaders.
            </p>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Platform</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/features" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/security" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Security
                </Link>
              </li>
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Community</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/events" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Events
                </Link>
              </li>
              <li>
                <Link to="/magazine" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Magazine
                </Link>
              </li>
              <li>
                <Link to="/success-stories" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Success Stories
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/help-center" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" onClick={handleLinkClick} className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Success Club. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
